var map = {
	"./Cell-Row-0-Col-0.png": 3729,
	"./Cell-Row-0-Col-1.png": 5864,
	"./Cell-Row-0-Col-2.png": 1139,
	"./Cell-Row-1-Col-0.png": 9864,
	"./Cell-Row-1-Col-1.png": 993,
	"./Cell-Row-1-Col-2.png": 3562,
	"./Cell-Row-2-Col-0.png": 8895,
	"./Cell-Row-2-Col-1.png": 5606,
	"./Cell-Row-2-Col-2.png": 5933,
	"./Cell-Row-3-Col-0.png": 2086,
	"./Cell-Row-3-Col-1.png": 5887,
	"./Cell-Row-3-Col-2.png": 612,
	"./Cell-Row-4-Col-0.png": 6845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6019;